import useAuth from "../useAuth";

export default function useRoles(roles) {
  const { user } = useAuth();
  return roles.includes(user?.role);
}
